// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (min-width:992px){
    .ellanse-logo{
        margin-bottom: 0!important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/brands/pages/EllansePage.css"],"names":[],"mappings":";AACA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["\n@media (min-width:992px){\n    .ellanse-logo{\n        margin-bottom: 0!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
